import { AiOutlineLineChart as _AiOutlineLineChart } from "@react-icons/all-files/ai/AiOutlineLineChart.js";
import { FiGrid as _FiGrid } from "@react-icons/all-files/fi/FiGrid.js";
import { MdInsights as _MdInsights } from "@react-icons/all-files/md/MdInsights.js";
import { GiRadarSweep as _GiRadarSweep } from "@react-icons/all-files/gi/GiRadarSweep.js";
import { BiFolder as _BiFolder } from "@react-icons/all-files/bi/BiFolder.js";
import { FiActivity as _FiActivity } from "@react-icons/all-files/fi/FiActivity.js";
import { FiCpu as _FiCpu } from "@react-icons/all-files/fi/FiCpu.js";
import { PiSparkleFill } from 'react-icons/pi';
import { ReactComponent as ObservationDeckIcon } from 'app/assets/observation-deck-logo.svg';
export const landingDisplayLabels = {
  observationDeck: 'Observation Deck',
  nmsDashboard: 'NMS Dashboard',
  networkExplorer: 'Network Explorer',
  library: 'Library',
  synthetics: 'Synthetics',
  explorer: 'Data Explorer',
  alerting: 'Alerting',
  insights: 'Insights',
  dashboard: 'Dashboard',
  'saved-view': 'Saved View',
  'quick-view': 'Quick View',
  'market-intel': 'Market Intelligence',
  aiAdvisor: 'AI Advisor'
};
export const landingRoutes = {
  observationDeck: () => '/v4/home',
  nmsDashboard: () => '/v4/nms',
  networkExplorer: () => '/v4/core',
  library: () => '/v4/library',
  alerting: () => '/v4/alerting',
  insights: () => '/v4/core/insights',
  explorer: () => '/v4/core/explorer',
  synthetics: () => '/v4/synthetics',
  'market-intel': () => '/v4/service-provider/market-intel',
  dashboard: v => `/v4/library/dashboards/${v}`,
  'saved-view': v => `/v4/library/saved-views/${v}`,
  'quick-view': v => `/v4/core/quick-views/${v}`,
  aiAdvisor: () => '/v4/core/ai-advisor'
};

/**
 * Maps each landing page type key to the icon value accepted by the core `Icon` component —
 * either a react-icons component, an SVG ReactComponent, or a Blueprint icon name string.
 */
export const landingDisplayIcons = {
  observationDeck: ObservationDeckIcon,
  nmsDashboard: _FiCpu,
  networkExplorer: _FiActivity,
  library: _BiFolder,
  synthetics: _GiRadarSweep,
  explorer: _FiActivity,
  alerting: 'shield',
  insights: _MdInsights,
  dashboard: _FiGrid,
  'saved-view': _AiOutlineLineChart,
  'quick-view': 'linked-squares',
  'market-intel': 'heatmap',
  aiAdvisor: PiSparkleFill
};